import React, { useEffect, useRef } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import ActivityLoader from '../../components/Common/ActivityLoader';
import Notification from '../../components/Common/Notification';
import Pagination from '../../components/Common/Pagination';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import printContent from '../../util/araknerdlib';
import { useNavigate } from 'react-router-dom';
import * as XLSX from "xlsx";
import StudentListFilter from '../../components/Student/StudentListFilter';
import { useContact } from '../../DataStore/ContactContext';
import { useStudent } from '../../DataStore/StudentContext';
import ContactFilter from '../../components/Student/ContactFilter';

const ContactCenterPage = () => {
    const { listing, metaData, setCurrentPage, getContacts, mounted } = useContact();
    const {loadProfile} = useStudent();
    const reportRef = useRef();

    useEffect(() => {
        if(!mounted){
            getContacts();
        }
    }, []);

     const goToStudentProfile = (profileInfo)=>{
        loadProfile(profileInfo.id);
        navigate('/student-profile');
    }

    const navigate = useNavigate();

    const PageActions = () => (
        <>
            <ActionDropdownItem iconClass="fa fa-sync text-primary" label="Refresh" onClick={() => getContacts(true)} />
            <ActionDropdownItem iconClass="fa fa-print text-secondary" label="Print" onClick={() => printContent(reportRef, "Class List")} />
            <ActionDropdownItem iconClass="fa fa-file-excel text-success" label="Export" onClick={handleExport} />
        </>
    );

  const handleExport = () => {
    if (!Array.isArray(listing) || listing.length === 0) {
        return;
    }

    const exportData = listing.map((student, index) => {
        const contacts = Array.isArray(student.contact_info) && student.contact_info.length > 0
            ? student.contact_info
                  .map((cInfo) => `${cInfo?.contact_name || '-'}: ${cInfo?.contact || '-'}`)
                  .join('\n')
            : '-';

        return {
            "#": index + 1,
            "Reg. No": student.reg_no || '-',
            "Full Name": student.full_name || '-',
            "Gender": student.sex || '-',
            "Class": student.class?.class_name || '-',
            "Stream": student.stream?.stream_name || '-',
            "Residence": student.residence?.residence_name || '-',
            "Contacts": contacts,
        };
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);

    worksheet['!cols'] = [
        { wch: 6 },
        { wch: 18 },
        { wch: 28 },
        { wch: 12 },
        { wch: 12 },
        { wch: 16 },
        { wch: 16 },
        { wch: 40 },
    ];

    const range = XLSX.utils.decode_range(worksheet['!ref']);

    // Set row heights and wrap contacts column
    worksheet['!rows'] = [];
    for (let row = 1; row <= range.e.r; row++) {
        const contactCellRef = XLSX.utils.encode_cell({ r: row, c: 7 });
        const contactValue = worksheet[contactCellRef]?.v || '';

        const lineCount = String(contactValue).split('\n').length;
        worksheet['!rows'][row] = { hpt: Math.max(20, lineCount * 16) };
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Contact Listing");

    XLSX.writeFile(workbook, "Students_contacts.xlsx");
};

    return (
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="Contact Center"
                    description="Lising of all students with their contacts."
                    iconClass="fa fa-users"
                    sticky={true}
                    PageActions={PageActions}
                    Pagination={metaData ? (
                        <Pagination
                            metaData={metaData}
                            onPageChange={(page) => setCurrentPage(page)}
                            loadMore={true}
                        />
                    ) : null}
                />

                <div>
                    <div className="card mb-4">
                        <ContactFilter
                             handleExport={handleExport}
                             title='Contact Listing'
                             description='View & manage contacts'
                              />
                        <div className="card-body">
                            <div className="table-responsive" ref={reportRef}>
                            {Array.isArray(listing) ? (
                                <table className="table table-striped table-bordered" style={{fontSize: '12px'}}>
                                    <thead className="thead-light">
                                        <tr>
                                            <th>#</th>
                                            <th>Reg. No</th>
                                            <th>Full Name</th>
                                            <th>Gender</th>
                                            <th>Class</th>
                                            <th>Stream</th>
                                            <th>Residence</th>
                                            <th>Contacts</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listing.map((student, index) => (
                                            <tr key={student.id}>
                                                <td>{index + 1}</td>
                                                <td>{student.reg_no}</td>
                                                <td>{student.full_name.toUpperCase()}</td>
                                                <td>{student.sex.toUpperCase()}</td>
                                                <td>{student.class?.class_name || '-'}</td>
                                                <td>{student.stream?.stream_name || '-'}</td>
                                                <td>{student.residence?.residence_name.toUpperCase() || '-'}</td>
                                                <td>
                                                    {Array.isArray(student.contact_info) && student.contact_info.length > 0 ? (
                                                        student.contact_info.map((cInfo, cKey) => (
                                                            <span key={cKey}>
                                                                {cInfo?.contact || '-'}
                                                                <br />
                                                            </span>
                                                        ))
                                                    ) : (
                                                        <span>-</span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : listing === '404' ? (
                                <Notification type="info" message="No contacts found." closable={false} />
                            ) : (
                                <ActivityLoader />
                            )}
                        </div>
                     </div>
                    </div>
                </div>
            </MainContent>
        </PageContainer>
    );
};

export default ContactCenterPage;
